export default {
  'ComparisonNav.title': 'продуктов в сравнении',
}
